// extracted by mini-css-extract-plugin
export default {"container":"paginator_container__w-mnw","arrowContainer":"paginator_arrowContainer__G6ig0","textContainer":"paginator_textContainer__mnRHQ"};